import { render, staticRenderFns } from "./Addendum.vue?vue&type=template&id=5f1296ad&scoped=true&"
import script from "./Addendum.vue?vue&type=script&lang=js&"
export * from "./Addendum.vue?vue&type=script&lang=js&"
import style0 from "./Addendum.vue?vue&type=style&index=0&id=5f1296ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1296ad",
  null
  
)

export default component.exports